import { makeObservable } from 'mobx';

export const createObservableInstance = (Clazz, ...args) => {
  const clazz = new Clazz(...args);
  if (Clazz.annotations) {
    makeObservable(clazz, Clazz.annotations);
  }
  clazz.init?.();
  return clazz;
};

export const waitSnapshot = () => {};

// export const mixin = (...classes) => {
//   return classes.reduce(
//     (AccClazz, Clazz) => {
//       if (AccClazz === null) {
//         return class extends Clazz {}
//       }
//
//
//     },
//     null
//   );
// };
